import { NextPage } from "next";

import Container from "@mui/material/Container";

import ContactSection from "sections/nfcTagsPage/ContactSection";

import Layout from "components/Layout";

const ContactUsPage: NextPage = () => {
  return (
    <Layout>
      <Container>
        <ContactSection
          boxProps={{
            mb: { xs: 12, lg: 16 },
          }}
        />
      </Container>
    </Layout>
  );
};

export default ContactUsPage;
